/* global axios */

import ApiClient from '../ApiClient';

class WoowCrmAPI extends ApiClient {
  constructor() {
    super('integrations/woow_crm', { accountScoped: true });
  }

  getContactSummary(conversationId) {
    return axios.get(`${this.url}/contact_summary`, {
      params: { conversation_id: conversationId },
    });
  }

  getFormOptions() {
    return axios.get(`${this.url}/form_options`);
  }

  searchUsers(query, page = 1) {
    return axios.get(`${this.url}/search_users`, {
      params: { q: query, page },
    });
  }

  createTicket(conversationId, data) {
    return axios.post(`${this.url}/create_ticket`, {
      conversation_id: conversationId,
      ...data,
    });
  }

  createLead(conversationId, data) {
    return axios.post(`${this.url}/create_lead`, {
      conversation_id: conversationId,
      ...data,
    });
  }

  linkCustomer(conversationId, userId) {
    return axios.post(`${this.url}/link_customer`, {
      conversation_id: conversationId,
      user_id: userId,
    });
  }

  unlinkCustomer(conversationId) {
    return axios.delete(`${this.url}/unlink_customer`, {
      params: { conversation_id: conversationId },
    });
  }
}

export default new WoowCrmAPI();
